import { SyntheticEvent } from "react";
import { Button } from "@/shared/ui";

type Props = {
  onSubmit: (e: SyntheticEvent<HTMLFormElement>) => void;
};

export default function AuthResetTfaEmail({ onSubmit }: Props) {
  return (
    <div className="gap-3 grow flex flex-col">
      <div className="text-16 text-white font-medium">Восстановление доступа к аккаунту</div>
      <div className="text-15 text-white/60 font-medium">
        Если у вас нет доступа к средствам восстановления аккаунта свяжитесь с администрацией
        перейдя по ссылке ниже и заполнив соответствующую форму на нашем сайте.
      </div>
      <Button submit className="mt-auto w-full">
        СВЯЗАТЬСЯ С АДМИНИСТРАЦИЕЙ
      </Button>
    </div>
  );
}
